// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingPage_container__GrnPW index_flex__3nqeG index_items-center__1yi5K index_justify-center__18Bm4"};